import React from 'react';
import {
  Button, Modal, Spinner,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsClockHistory } from 'react-icons/bs';
import { extractApiPayload } from 'screens/Admin/Accounts/components/syncSolicitudDocModalHelpers';
import useSyncSolicitudDocStatusPolling from 'screens/Admin/Accounts/components/useSyncSolicitudDocStatusPolling';

type SyncSolicitudDocProgressModalProps = {
  show: boolean;
  accountId: number;
  runId: string;
  getSyncStatusAction: (
    id: number,
    opts?: { runId?: string; silent?: boolean },
  ) => Promise<any>;
  onTerminal: ( response: any ) => void;
  onTimeout: () => void;
  onClose: () => void;
};

function SyncSolicitudDocProgressModal( {
  show,
  accountId,
  runId,
  getSyncStatusAction,
  onTerminal,
  onTimeout,
  onClose,
}: SyncSolicitudDocProgressModalProps ) {
  const { t } = useTranslation();
  const { lastResponse } = useSyncSolicitudDocStatusPolling( {
    accountId,
    runId,
    enabled: show,
    getSyncStatusAction,
    onTerminal,
    onTimeout,
  } );

  const payload = lastResponse ? extractApiPayload( lastResponse ) : {};
  const lastMessage = String( payload.lastMessage ?? payload.LastMessage ?? '' );

  return (
    <Modal show={show} centered size="lg" onHide={onClose} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          <BsClockHistory className="text-primary" />
          {t( 'admin.account.syncSolicitudDocProgressTitle' )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center py-4">
        <Spinner animation="border" className="mb-3" />
        <p className="mb-2">{t( 'admin.account.syncSolicitudDocProgressHint' )}</p>
        <p className="text-muted small mb-0">
          {t( 'admin.account.syncSolicitudDocRunIdLabel' )}
          {' '}
          <code>{runId}</code>
        </p>
        {lastMessage ? (
          <p className="text--sm mt-3 mb-0 text-start px-2">
            {lastMessage}
          </p>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>
          {t( 'close' )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SyncSolicitudDocProgressModal;
